/*
 * File: cell-ledger-reason.ts
 * Created: 2026-02-03
 * Author: Val Liu
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellLedgerReason extends BaseTableBodyCell {
    get sourceType() {
        return String(this.row?.source ?? "").toUpperCase();
    }

    get primaryText() {
        const key = {
            INITIAL_CREDIT: "w_LedgerReasonInitialCredit",
            USER_DEPOSIT: "w_LedgerReasonPayuniTopup",
            PROMO_CREDIT: "w_LedgerReasonPromoRedeem",
            USAGE_DEBIT: "w_LedgerReasonTranslationDebit",
            REFUND: "w_LedgerReasonTranslationRefund",
        }[this.sourceType];
        if (key) return this.$_(key);
        const fallback = this.value ?? this.row?.reason ?? this.row?.name;
        return fallback ? String(fallback) : "-";
    }

    get secondaryText() {
        const meta = (this.row as any)?.meta ?? (this.row as any)?.metadata ?? null;
        if (this.sourceType === "USER_DEPOSIT") {
            const tradeNo = meta?.tradeNo ?? meta?.merTradeNo;
            return tradeNo ? `#${tradeNo}` : "";
        }
        if (this.sourceType === "PROMO_CREDIT") {
            const code = meta?.code ?? meta?.promotionCode;
            return code ? `#${code}` : "";
        }
        if (this.sourceType === "REFUND") {
            const fileName =
                meta?.fileName ??
                meta?.filename ??
                meta?.inputFileName ??
                meta?.inputFilename;
            return fileName ? String(fileName) : "";
        }
        const metaName =
            meta?.fileName ??
            meta?.filename ??
            meta?.inputFileName ??
            meta?.inputFilename;
        if (metaName) return String(metaName);
        return "";
    }

    get iconClass() {
        if (this.sourceType === "USER_DEPOSIT" || this.sourceType === "INITIAL_CREDIT")
            return "fa-credit-card";
        if (this.sourceType === "PROMO_CREDIT") return "fa-tag";
        if (this.sourceType === "REFUND") return "fa-rotate-left";
        return "fa-file-alt";
    }
}
